import {iContent} from "@/Engine/apiInterfaces";
import {Item} from "@/Engine/Item";
import {Vector3} from "three";

export class Shelf extends Item {

    constructor(props: iContent, color: string) {
        super(props);
        this.setColor(color);
        this.position = new Vector3(0, 0.340, 0.016)
    }
}
